// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__LKAkA","banner":"Banner_banner__AW-sg"};